import * as React from "react";
import { AppBar } from "react-admin";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import { Logo } from "./Logo";

const useStyles = makeStyles({
  bar: {
    background: "#171f39",
  },
  title: {
    flex: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  spacer: {
    flex: 1,
  },
  logo: {
    maxWidth: "115px",
  },
});

const MyAppBar = (props: any) => {
  const classes = useStyles();
  return (
    <AppBar {...props} className={classes.bar}>
      <Typography
        variant="h6"
        color="inherit"
        className={classes.title}
        id="react-admin-title"
      />
      <Logo />
      <span className={classes.spacer} />
    </AppBar>
  );
};

export default MyAppBar;
